module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-reschedule.d97d5328.png";